//import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { createCATConvenios, createCATConveniosFormValues } from '../models/CATConveniosCreate';
import { CATEdiciones, getEdiciones } from '../models/CATEdiciones';
//import { store } from './store';

export default class CATConveniosStore {
    CATConveniosRegistry = new Map<any, createCATConvenios>();
    CATEdicionesRegistry = new Map<any, getEdiciones>();
    

    selectedCATConvenios: createCATConvenios | undefined = undefined;
    selectedCATEdiciones: CATEdiciones | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    entidadSelecI:any

    constructor() {
        makeAutoObservable(this)
    }

    get CATEdicionesByCodigo() {
        return Array.from(this.CATEdicionesRegistry.values());
    }

    getEdicionesConvenios = async() => {
        this.loadingInitial = true;
        try {
            const CCTCuentas: getEdiciones[] = await agent.getCATEdiciones.getEdicionesConv();
            CCTCuentas.forEach(element => {
                this.setEdiciones(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    private setEdiciones = (data: getEdiciones) => {
        this.CATEdicionesRegistry.set(data.id, data);
    }

    // private getCATConvenios = (idCliente: any) => {
    //     return this.CATConveniosRegistry.get(idCliente);
    // }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createConvenios = async (createCATConvenios: createCATConveniosFormValues) => {
        try {
            await agent.Convenios.create(createCATConvenios).then(response => {
                if(response === "Registro creado exitosamente"){
                    toast.success(response)
                }else{
                    toast.error(response)
                }
            })
            runInAction(() => {
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    buscarEntida = async (usuario:any) => {
        try {
            await agent.Convenios.buscarEntidades(usuario).then(response => {
                this.entidadSelecI = response.entidad
            });
            this.setLoadingInitial(false);
        } catch (error) {
            this.entidadSelecI = undefined
            this.setLoadingInitial(false);
        }
    }

    // updateCATConvenios = async (createCATConvenios: createCATConveniosFormValues) => {
    //     try {
    //         await agent.CATConvenios.update(createCATConvenios);
    //         runInAction(() => {
    //             if (createCATConvenios.idCliente) {
    //                 let updateCATConvenios = {...this.getCATConvenios(createCATConvenios.idCliente), ...createCATConvenios}
    //                 this.CATConveniosRegistry.set(createCATConvenios.idCliente, updateCATConvenios as createCATConvenios);
    //                 this.selectedCATConvenios = updateCATConvenios as createCATConvenios
    //                 this.loading = false;
    //             }
                   
    //         } )
    //     } catch (error) {
    //     }
    // }

    // deleteCATConvenios = async (idCliente: string) => {
    //     this.loading = true;
    //     try {
    //         await agent.CATConvenios.delete(idCliente);
    //         runInAction(() => {
    //             this.CATConveniosRegistry.delete(idCliente);
    //             this.loading = false;
    //         })
    //     } catch (error) {
    //         runInAction(() => {
    //             this.loading = false;
    //         })
    //     }
    // }
}